/** Mirrors the fixed vocab validated server-side in
 * server/internal/httpapi/server.go (scriptFlagVocab/pageFlagVocab). */
export const SCRIPT_FLAGS = ["complete", "incomplete", "needs-rescan", "mismatched-pages"] as const;
export const PAGE_FLAGS = ["good", "blurry", "cut-off", "duplicate", "unreadable"] as const;
